import axios from "axios";
import { toast } from "vue3-toastify";
import { isArray, isBoolean, isObject } from "mathjs";

class API {
  token;
  $root;
  baseURL = window.location.origin+'/api/';
  // baseURL = 'http://itech-ecs.flyinghub.fr/api/';

	constructor() {
	}

  init = function($root) {
    self.$root = $root;
  }

  getJwt = function () {
    let jwt = localStorage.getItem("fe_jwt");

    if (
      jwt != null &&
      jwt != undefined &&
      jwt != ""
    ) {
      return jwt;
    }

    /*
    if (
      this.$root?.jwt != null &&
      this.$root?.jwt != undefined &&
      this.$root?.jwt != ""
    ) {
      return $this.$root.jwt;
    }
    */

    return "";
  }

  buildUrl = function(url) {
    return this.baseURL + url;
  }

  args = function(url, data) {
    if (data === undefined) {
      data = {};
    }

    let args = "";

    for (let key in data) {
      let value = data[key];

      if( isBoolean(value) ) {
        value = value ? "true" : "false";
      }
      else if( isObject(value) || isArray(value)  ) {
        value = JSON.stringify(value);
      }

      args += key + "=" + encodeURIComponent(value) + "&";
    }

    // remove last &
    if(args.length > 0){
      args = args.slice(0, -1);
    }

    return url + "?" + args;
  }

  getFirstData = function (data) {
    if (typeof data == "undefined" || data == null) {
      return {};
    }
    else if (data.length == 0) {
      return {};
    }
    return data[0];
  }

  dataParser = function (data) {
    if (typeof data == "undefined" || data == null) {
      return {};
    }
    else if (data.length == 0) {
      return {};
    }

    if(typeof data == "object") {
      let keys = Object.keys(data);

      keys.forEach((key) => {
        if (data[key] == null) {
          data[key] = "";
        }
        else if (isObject(data[key]) || isArray(data[key])) {
          data[key] = JSON.stringify(data[key]);
        }
      });
      return data;
    }

    if(typeof data == "array") {
      let keys = Object.keys(data[0]);

      data.forEach((item) => {
        keys.forEach((key) => {
          if (item[key] == null) {
            item[key] = "";
          }
          else if (isObject(item[key]) || isArray(item[key])) {
            item[key] = JSON.stringify(item[key]);
          }
        });
      });
      return data;
    }
  }

  /** ----------- */

  async fetchBlob(url) {
    let r = axios({
      method: 'get',
      responseType: 'blob',
      url: this.buildUrl(url),
      headers: {
        'Authorization': 'Bearer ' + this.getJwt(),
      }
    });
    return r.then((response) => {
      return response.data;
    }).catch((response)=> {
      return null;
    })
  }

  async fetchBlobLocal(url) {
    let r = axios({
      method: 'get',
      responseType: 'blob',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + this.getJwt(),
        'Content-Type' : 'application/zip',
      }
    });
    return r.then((response) => {
      return response.data;
    }).catch((response)=> {
      return null;
    })
  }

  /** ----------- */

  async login(url, data) {
    url = this.args(url, data);

    let r = axios({
      method: 'get',
      url: this.buildUrl(url),
      headers: {
        'Authorization': 'Bearer ' + this.getJwt()
      }
    });

    return r.then((r) => {
      return r;
    }).catch((response) => {
      return r;
    })
  }

  async get(url, data) {
    url = this.args(url, data);

    let r = axios({
      method: 'get',
      url: this.buildUrl(url),
      headers: {
        'Authorization': 'Bearer ' + this.getJwt()
      }
    });

    return r.then((response) => {
      return this.normalResponse(response, url, "get");
    }).catch((response)=> {
      return this.normalResponse(response, url, "get");
    })
	}

  async post(url, data) {
    // url = this.args(url, data);

    data = this.dataParser(data);

    let r = axios({
      method: 'post',
      url: this.buildUrl(url),
      // body: JSON.stringify(data),
      data: (data),
      headers: {
        'Authorization': 'Bearer ' + this.getJwt(),
        // 'Content-Type': 'multipart/form-data'
      }
    });

    return r.then((response) => {
      return this.normalResponse(response, url, "post");
    }).catch((response) => {
      return this.normalResponse(response, url, "post");
    })
  }

  async put(url, data){
    // url = this.args(url, data);
    // if (body == undefined) {
    //   var r = axios({
    //     method: 'put',
    //     url: this.buildUrl(url),
    //     headers: {
    //       'Authorization': 'Bearer ' + this.getJwt()
    //     }
    //   });
    // }
    // else {
    // }

    data = this.dataParser(data);

    var r = axios({
      method: 'put',
      url: this.buildUrl(url),
      headers: {
        'Authorization': 'Bearer ' + this.getJwt(),
        // 'Content-Type': 'multipart/form-data'
      },
      // data: JSON.stringify(body)
      // data: JSON.stringify(data)
      data: (data)
    });

    return r.then((response) => {
      return this.normalResponse(response, url, "put");
    }).catch((response) => {
      return this.normalResponse(response, url, "put");
    })
  }

  async delete(url, data) {
    let r = axios.delete(this.buildUrl(url), {
      headers: {
        'Authorization': 'Bearer ' + this.getJwt()
      }
    });

    return r.then((response) => {
      return this.normalResponse(response, url, "delete");
    })
  }

  postFile(url, file) {
    var formdata = new FormData();
    formdata.append("", file);

    let r = axios.post(
      this.buildUrl(url),
      formdata, {
        headers: {
          'Authorization': 'Bearer ' + this.getJwt(),
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return r.then((response) => {
      return this.normalResponse(response, url, "postFile");
    }).catch((response) => {
      return this.normalResponse(response, url, "postFile");
    })
  }

  postFile2(url, data, file, type) {
    if(type == 'blob') {
      file = new File([file], 'missionKMZ.kmz');
    }

    var formdata = new FormData();
    formdata.append('', file);

    url = this.args(url, data);

    let r = axios.post(
      this.buildUrl(url),
      formdata,
      {
        headers: {
          'Authorization': 'Bearer ' + this.getJwt(),
          'Content-Type': 'multipart/form-data'
        },
      }
    );

    return r.then((response) => {
      return this.normalResponse(response, url, "postFile");
    }).catch((response) => {
      return this.normalResponse(response, url, "postFile");
    })
  }

  model3D(url, data, file, type) {
    const formData = new FormData();
    formData.append("", file);

    url = this.args(url, data);

    const config = {
      method: 'post',
      url: this.buildUrl(url),
      headers: {
        'Authorization': 'Bearer ' + this.getJwt(),
        'Content-Type': 'multipart/form-data'
      },
      data: formData
    };

    let r = axios(config);

    return r.then((response) => {
      return this.normalResponse(response, url, "postFile");
    }).catch((response) => {
      return this.normalResponse(response, url, "postFile");
    })
  }

  putFile(url, file) {
    var formdata = new FormData();
    formdata.append("file", file);

    let r = axios.put(
        this.buildUrl(url),
        formdata, {
        headers: {
          'Authorization': 'Bearer ' + this.getJwt(),
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return r.then((response) => {
      return this.normalResponse(response, url, "putFile");
    }).catch((response) => {
      return this.normalResponse(response, url, "putFile");
    })
  }
  /** ----------- */

  normalResponse = function (response, url, from) {
    // ERROR CATCH
    if (response?.response != undefined) {
      response = response.response;
    }

    // USER NO JWT VALID TOKEN
    if (response?.data?.Error == "Invalid Token") {
      $root.user.logout('jwt');
    }

    // NORMAL RESPONSE
    if (response.status === 200) {
      return response.data;
    }
    if (response.status === 401) {
      return response.data;
    }
    else if (response.status === 404) {
      if (response?.data?.Error != undefined) {
        return response.data;
      }
      return [];
    }
    else if (response.status == 500) {
      BUGS.errors.push({
        url: url,
        from: from,
        response: response
      });

      if (response?.data?.Error != undefined) {
        return response.data;
      }
      return [];
    }
    // API DOWN
    else if (response.status == 503) {
      BUGS.errors.push({
        url: url,
        from: from,
        response: response
      });
      self.$root.api_down()
    }

    // SECURITY
    return [];
  }
}

export default new API();
